import { render, staticRenderFns } from "./ExtensionQueueStatus.vue?vue&type=template&id=3120666f&scoped=true&"
import script from "./ExtensionQueueStatus.vue?vue&type=script&lang=js&"
export * from "./ExtensionQueueStatus.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionQueueStatus.vue?vue&type=style&index=0&id=3120666f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120666f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
